import { render, staticRenderFns } from "./orderDtlView.vue?vue&type=template&id=40fb518e&scoped=true"
import script from "./orderDtlView.vue?vue&type=script&lang=js"
export * from "./orderDtlView.vue?vue&type=script&lang=js"
import style0 from "./orderDtlView.vue?vue&type=style&index=0&id=40fb518e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb518e",
  null
  
)

export default component.exports